module.exports = __webpack_public_path__ + "6e51387d5c01f605a085cf57af42d1c4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/kies_zelf_een_instrument_en_bespeel_deze_op_de_piano.mp3
// module id = 85
// module chunks = 0